import { LoaderFunctionArgs, Outlet } from 'react-router';

import { TCustomRouteObject, THandle } from '@/shared/types/router.types';
import { UserRoleFragment } from '@/shared/types/types.generated';

export const roleInnerRoutes: TCustomRouteObject[] = [
  {
    path: ':userRoleId/:tabId?',
    lazy: async () => {
      const { RoleRoute } = await import('./role');
      return { Component: RoleRoute };
    },
    shouldRevalidate: () => false,
    loader: async (args: LoaderFunctionArgs) => {
      const { roleLoader } = await import('./role');
      return roleLoader(args);
    },
    handle: {
      crumb: {
        label: (data: UserRoleFragment) => data.name,
      },
    },
  },
];

export const rolesRouteHandle: THandle = {
  crumb: {
    label: 'roles',
    localized: true,
  },
  permission: { action: 'ident:readUserRole' },
};

export const rolesRoutes: TCustomRouteObject = {
  path: '/roles',
  Component: () => <Outlet />,
  handle: rolesRouteHandle,
  children: [
    {
      index: true,
      lazy: async () => {
        const { RolesListRoute } = await import('./roles');
        return { Component: RolesListRoute };
      },
    },
    {
      path: 'new',
      lazy: async () => {
        const { CreateRoleRoute } = await import('./create-role');
        return { Component: CreateRoleRoute };
      },
      shouldRevalidate: () => false,
      handle: {
        crumb: {
          label: 'new_role',
          localized: true,
        },
      },
    },
    ...roleInnerRoutes,
  ],
};
